/**
 * CR098: Loading skeleton for DealGiftCard
 * 
 * Shown when config is not yet loaded to prevent silent fallback to hardcoded mappings.
 */

import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

export function DealCardLoadingSkeleton() {
  return (
    <div className="group relative w-full max-w-[720px] mx-auto">
      <div className="relative rounded-3xl overflow-hidden bg-white shadow-[0_10px_30px_rgba(0,0,0,0.08)] border border-black/5">
        {/* Top Band Skeleton */}
        <div className="h-20 md:h-24 bg-gradient-to-r from-black/90 to-black/70 flex items-center gap-3 px-6 pr-36 relative">
          <Skeleton className="h-10 w-24 bg-white/10" />
          <Skeleton className="h-6 w-32 bg-white/10" />
        </div>

        {/* Corner Ribbon Skeleton */}
        <div className="absolute top-0 right-0 w-36 h-36 bg-muted/50" style={{
          clipPath: "polygon(100% 0, 100% 100%, 0 0)"
        }} />

        {/* Body Skeleton */}
        <div className="p-5 md:p-6 space-y-3">
          {/* Badges Row */}
          <div className="flex items-center gap-2">
            <Skeleton className="h-5 w-16 rounded-full" />
            <Skeleton className="h-5 w-14 rounded-full" />
            <Skeleton className="h-5 w-24 rounded-full" />
          </div>

          {/* Headline */}
          <Skeleton className="h-5 w-3/4" />

          {/* Value */}
          <Skeleton className="h-4 w-1/2" />

          {/* Meta Block */}
          <div className="mt-3 space-y-2">
            <Skeleton className="h-3 w-2/3" />
            <Skeleton className="h-3 w-1/2" />
          </div>

          {/* Details Section */}
          <div className="pt-3 border-t border-black/5 mt-2 space-y-2">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-4/5" />
          </div>

          {/* Actions */}
          <div className="mt-4 flex gap-2">
            <Skeleton className="h-9 w-24 rounded-full" />
            <Skeleton className="h-9 w-20 rounded-full" />
          </div>

          {/* Footer */}
          <div className="flex items-center justify-between pt-3 border-t border-black/5 mt-4">
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-4 w-16" />
          </div>
        </div>
      </div>
      
      {/* Loading indicator text */}
      <div className="absolute inset-0 flex items-center justify-center bg-white/60 rounded-3xl">
        <span className="text-sm text-muted-foreground animate-pulse">
          Loading card config...
        </span>
      </div>
    </div>
  );
}
